<div class="vertual">
  <div class="contant">
    <h4>Free Live Virtual Informational Seminar</h4>
    <p>
      Join us live and engage in highly interactive, hands-on sessions led by top industry experts.
      Dive deep, ask questions in real-time, and get practical insights you can apply immediately.
    </p>
  </div>

  <div class="days" *ngIf="targetDate">
    <h2 class="day-text">
      {{ days > 0 ? 'Only ' + days + ' Day' + (days > 1 ? 's' : '') + ' Left!' : 'Starting Soon!' }}
    </h2>

    <div class="count">
      <div class="time-box">
        <h2>{{ days | number: '2.0' }}</h2>
        <p>Days</p>
      </div>
      <div class="line"></div>

      <div class="time-box">
        <h2>{{ hours | number: '2.0' }}</h2>
        <p>Hours</p>
      </div>
      <div class="line"></div>

      <div class="time-box">
        <h2>{{ minutes | number: '2.0' }}</h2>
        <p>Minutes</p>
      </div>
      <div class="line"></div>

      <div class="time-box">
        <h2>{{ seconds | number: '2.0' }}</h2>
        <p>Seconds</p>
      </div>
    </div>
  </div>

  <div class="button-row">
    <button class="spot-btn" (click)="onSecureSpot()">Secure Your Spot</button>
    <button class="view-btn" (click)="goToLiveSession()">View All</button>
  </div>
</div>
